import {ofType, unionize, UnionOf} from 'unionize';
export type EmptyFilterOption = {};
export type FilterOption = {
  name: string;
  value: string;
};
export const FilterOptionValue = unionize({
  EmptyOption: ofType<EmptyFilterOption>(),
  SelectedOption: ofType<FilterOption>(),
});
export type FilterOptionUnion = UnionOf<typeof FilterOptionValue>;
